import request from '@/utils/request';

//单元测试执行
export function getTest(values) {
  const { id } = values;
  return request(`/decision/rule/rule-output-result/test/${id}`, {
    method: 'POST',
    data: values,
  });
}
//编辑规则管理列表
export function editRuleManaList(values) {
  const { parentId } = values || {};
  values['parentId'] = null;
  return request(`/decision/rule/${parentId}`, {
    method: 'PUT',
    data: values,
  });
}
//删除规则管理列表
export function deleteRuleManaList(values) {
  const { id } = values || {};
  return request(`/decision/rule/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
// 测试获取输出列表
export function getUnitTest(values) {
  const { id } = values || {};
  return request(`/decision/rule/rule-output-result/meta-data/${id}`, {
    method: 'GET',
  });
}
// // 测试获取输出列表
// export function getUnitTest(values) {
//   const { id } = values || {};
//   return request(`/decision/variable-input/meta-data/${id}`, {
//     method: 'GET',
//   });
// }
